<template>
<div>
  <p class="mt-6 mb-0 text--small text--bold">{{ documentsBundleTitle }}</p>
  <i18n-t class="mb-0"
        keypath="project.signing-checklist.dialogs.SigningChecklistDocumentsBundleSection.documentsBundleText"
        tag="p"
        scope="global"
  >
  <template #link>
      <a :href="documentsBundleLink"
          target="_blank"
          class="learnMoreLink font-weight-bold d-inline-flex align-center column-gap-2"
      >
      {{$t('project.signing-checklist.dialogs.SigningChecklistDocumentsBundleSection.documentsBundleTextLink')}}
      <app-material-icon 
        name="open_in_new"
        size="sm"
      />
      </a>
  </template>
  </i18n-t>
  <app-toggle :value="currentRoom.allowEnvelopeGrouping"
              :label="$t('project.signing-checklist.dialogs.SigningChecklistDocumentsBundleSection.toggleLabel')"
              :loading="patchRoomPending"
              :disabled="currentRoom.inClosing"
              data-locator="group-documents-toggle"
              :data-toggle-state="currentRoom.allowEnvelopeGrouping ? 'enabled' : 'disabled'"
              @update:model-value="onChangeEnvelopeGroupingToggle"
  />
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SigningChecklistDocumentsBundleSection',
  computed: {
    ...mapState('room', ['currentRoom', 'patchRoomPending']),
    documentsBundleTitle () {
      return this.currentRoom.allowEnvelopeGrouping ? this.$t('project.signing-checklist.dialogs.SigningChecklistDocumentsBundleSection.documentsBundleTitle') : this.$t('project.signing-checklist.dialogs.SigningChecklistDocumentsBundleSection.documentsBundleOffTitle')
    },
    documentsBundleLink () {
      if (this.$i18n.locale === 'fr') {
        return 'https://help.closd.com/fr/knowledge-base/comment-grouper-les-documents-a-signer-pour-vos-signataires-beta/'
      }

      return 'https://help.closd.com/en/knowledge-base/bundle-documents-in-the-signing-checklist-page-beta/'
    },
  },
  methods: {
    onChangeEnvelopeGroupingToggle () {
     this.$emit('change-toggle')
    },
  },
}
</script>
